import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Before App: the i18n instance must exist before the first component asks it
// for a string.
import "./i18n/index.js";
import App from "./App.jsx";
import "./styles/index.css";
// main.jsx
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
